/** Public Firebase web config (also mirrored in public/firebase-messaging-sw.js). */
export const FIREBASE_WEB_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "betbond2025.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "betbond2025",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "betbond2025.firebasestorage.app",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "41485164847",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
};

export const FIREBASE_VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";

export function isWebPushConfigured() {
  return Boolean(
    FIREBASE_WEB_CONFIG.apiKey &&
      FIREBASE_WEB_CONFIG.appId &&
      FIREBASE_VAPID_KEY
  );
}
